// extracted by mini-css-extract-plugin
export var tagCloud = "styles-module__tagCloud___w_IYr";
export var tag = "styles-module__tag___ukKHc";